// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"8ebb59f6","913":"8ebb59f6"}[chunkId] + ".chunk.css";
};